import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {TranslateService} from '@ngx-translate/core';
import {Mod} from '../../../../model/mod';
import {ModService} from '../../../../services/apiServices/business/mod.service';

@Component({
  selector: 'app-mod',
  templateUrl: './mod.component.html',
  styleUrls: ['./mod.component.css']
})
export class ModComponent implements OnInit {
  @Input() idCustomer: string;
  public enMod: Mod;
  public frMod: Mod;
  public successTitle: string;
  public errorTitle: string;
  public successMessage: string;
  public saveModFailureMsg: string;
  public saveModSuccessMsg: string;
  public resetModSuccessMsg: string;
  public resetModFailureMsg: string;

  constructor(private commonService: CommonService,
              private modService: ModService,
              private translate: TranslateService) {
  }

  public ngOnInit(): void {
    this.getTradForComponent();
    this.frMod = {
      line1: '',
      line2: '',
      line3: ''
    };
    this.enMod = {
      line1: '',
      line2: '',
      line3: ''
    };
    this.modService.getPlatformMessages().subscribe(response => {
      let messages = {};
      if (response.body && response.body.datas) {
        messages = response.body.datas
      }
      this.initMessages(messages);
    });

  }

  initMessages(messages: any) {
    let fr = '';
    let en = '';
    if (this.idCustomer) {
      if (messages && messages.hasOwnProperty(this.idCustomer)) {
        fr = messages[this.idCustomer].fr;
        en = messages[this.idCustomer].en;
      }
    } else {
      if (messages && messages.hasOwnProperty('DEFAULT')) {
        fr = messages.DEFAULT.fr;
        en = messages.DEFAULT.en;
      }
    }
    const fra = fr.split('<br>');
    const ena = en.split('<br>');
    this.frMod.line1 = fra[0] || '';
    this.frMod.line2 = fra[1] || '';
    this.frMod.line3 = fra[2] || '';
    this.enMod.line1 = ena[0] || '';
    this.enMod.line2 = ena[1] || '';
    this.enMod.line3 = ena[2] || '';
  }

  public deleteMessage(): void {
    let context = '';
    if (this.idCustomer) {
      context = this.idCustomer;
    }
    this.modService.clearPlatformMessages(context).subscribe(response => {
      if (response && response.bOK) {
        this.initMessages(response.datas);
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successTitle,
          detail: this.resetModSuccessMsg
        });
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.errorTitle,
          detail: this.resetModFailureMsg
        });
      }
    });
  }

  public saveMessage(): void {
    let frMessage = this.frMod.line1;
    let enMessage = this.enMod.line1;
    if (this.frMod.line2) {
      frMessage += '<br>' + this.frMod.line2;
    }
    if (this.frMod.line3) {
      frMessage += '<br>' + this.frMod.line3;
    }
    if (this.enMod.line2) {
      enMessage += '<br>' + this.enMod.line2;
    }
    if (this.enMod.line3) {
      enMessage += '<br>' + this.enMod.line3;
    }
    let context = '';
    if (this.idCustomer) {
      context = this.idCustomer;
    }
    this.modService.savePlatformMessages(frMessage, enMessage, context).subscribe(response => {
      if (response && response.bOK) {
        this.initMessages(response.datas);
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successTitle,
          detail: this.saveModSuccessMsg
        });
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.errorTitle,
          detail: this.saveModFailureMsg + ' : ' + response.sMsgError
        });
      }
    });
  }

  public getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((title: string) => {
      this.errorTitle = title;
    });
    this.translate.get('TOASTER.MODIFY_PASSWORD_ASK_OK').subscribe((message: string) => {
      this.successMessage = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.RESET_MOD_SUCCESS').subscribe((message: string) => {
      this.resetModSuccessMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.RESET_MOD_FAILURE').subscribe((message: string) => {
      this.resetModFailureMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.SAVE_MOD_SUCCESS').subscribe((message: string) => {
      this.saveModSuccessMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.SAVE_MOD_FAILURE').subscribe((message: string) => {
      this.saveModFailureMsg = message;
    });
  }
}
